import {PieceRemove} from '../../models/piece-remove';
import {PieceRemoveDto} from '../dto/piece-remove';

export function convertPieceRemoveModelToDto(dto: PieceRemove): PieceRemoveDto {
  return {
    BatchID: dto.batchId,
    PieceID: dto.pieceId,
  };
}
